import { render, staticRenderFns } from "./PlanDesk.vue?vue&type=template&id=6cd0d293&scoped=true"
import script from "./PlanDesk.vue?vue&type=script&lang=js"
export * from "./PlanDesk.vue?vue&type=script&lang=js"
import style0 from "./PlanDesk.vue?vue&type=style&index=0&id=6cd0d293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd0d293",
  null
  
)

export default component.exports